import { token } from '@amzn/stencil-design-tokens/js/web/utils';
import { cssValuesProp } from './cssProps';
export const getVariationBorderColor = _ref => {
  let {
    error,
    warning
  } = _ref;
  if (error) {
    return token('color.status.critical-border-default');
  }
  if (warning) {
    return token('color.status.warning-border-default');
  }
  return null;
};
export const getColor = (fallbackColor, error, warning) => {
  const variationBorderColor = getVariationBorderColor({
    error,
    warning
  });
  return variationBorderColor || fallbackColor;
};
export const getPropsStyles = (propsKeys, props) => {
  const styles = {};
  propsKeys.forEach(propKey => {
    if (props[propKey]) {
      styles[propKey] = props[propKey];
    }
  });
  return styles;
};
export const getSpacingStyles = (propsKeys, props, spaceAdapter) => {
  let styles = {};
  propsKeys.forEach(propKey => {
    styles = {
      ...styles,
      ...cssValuesProp(spaceAdapter, props[propKey], propKey)
    };
  });
  return styles;
};
export const px = value => typeof value === 'number' ? "".concat(value, "px") : value;

// Use in case a CSS variable returns a number but needs to be converted to pixels.
export const numberCSSVariableToPx = (value, themeValue) => {
  const isCSSVariable = typeof value === 'string' && value.match(/^var\(--[a-zA-Z0-9-]+\)$/);
  if (isCSSVariable) {
    const isThemeValueNumber = !!themeValue && typeof themeValue === 'number';
    return isThemeValueNumber ? "calc(".concat(value, " * 1px)") : value;
  }
  return value;
};
export const getBorderRadiusStyle = (radiusAdapter, borderRadius) => cssValuesProp(radiusAdapter, borderRadius, 'borderRadius');
export const addOutline = (width, offset, color, fillGap, radius, additionalStyle) => {
  return {
    rest: {
      outlineColor: color,
      outlineWidth: 0,
      outlineOffset: offset,
      ...additionalStyle
    },
    focus: {
      outlineColor: color,
      outlineWidth: width,
      outlineStyle: 'solid',
      outlineOffset: offset,
      ...(radius && {
        borderRadius: radius
      }),
      ...(fillGap && {
        boxShadow: "0 0 0 ".concat(px(fillGap.width), " ").concat(fillGap.color)
      }),
      ...additionalStyle
    }
  };
};